module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/collab/collab-scroll-01-fdb76a90c92109a0c03e452a7c47c5fa.jpg";